<template>
  <div class="customHint d-flex">
    <v-tooltip max-width="500" top v-if="!(imgs && Array.isArray(imgs) && imgs.length)">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" icon v-on="on" class="mx-0">
          <svg width="20" height="20" viewBox="0 0 24 24" class="ico-question svg"><path d="M11,18H13V16H11V18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6C9.79,6 8,7.79 8,10H10C10,8.9 10.9,8 12,8C13.1,8 14,8.9 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10C16,7.79 14.21,6 12,6Z" /></svg>
        </v-btn>
      </template>
      <span class="text-block">{{text}}</span>
    </v-tooltip>
    <v-dialog v-model="dialog" width="500" v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon class="mx-0">
          <svg width="24" height="24" viewBox="0 0 24 24" class="ico-question"><path d="M11,18H13V16H11V18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6C9.79,6 8,7.79 8,10H10C10,8.9 10.9,8 12,8C13.1,8 14,8.9 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10C16,7.79 14.21,6 12,6Z" /></svg>
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <template v-for="img in imgs">
            <img :src="img.url" :alt="img.name"><br>
          </template>
          <div class="pt-2">{{text}}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Hint',
  props: ['text', 'imgs'],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";
.customHint {

}

.svg {
  fill: $sale-file-btn-color;
}

.text-block {
  white-space: pre-wrap;
}

</style>
